module.exports = __webpack_public_path__ + "img/ai.b420683b.svg";